import * as Phaser from 'phaser'
import { Utils } from '@Util/utils'
import { NumberGrid } from './number-grid'
import { tweenWaitPromise } from '@Animation/utils'

export class NumberSelector extends Phaser.GameObjects.Container {
  currIndex: number = 0
  numberGrid: NumberGrid
  skipToEnd: boolean = false
  onNumberSelected: (index: number) => void
  preNumberSelected: (index: number) => Promise<void>
  miniGameSelections: number[]

  constructor(
    scene: Phaser.Scene,
    numberGrid: NumberGrid,
    miniGameSelections: number[],
    preNumberSelected: (index: number) => Promise<void> = async () => {},
    onNumberSelected: (number: number) => void = () => {},
  ) {
    super(scene)
    scene.add.existing(this)

    this.numberGrid = numberGrid
    this.onNumberSelected = onNumberSelected
    this.preNumberSelected = preNumberSelected
    this.miniGameSelections = miniGameSelections
  }

  async targetSingleNumber(number: number) {
    await this.numberGrid.selectNumber(number)
  }

  skipTargetSingleNumber(number: number) {
    this.numberGrid.selectNumber(number)
  }

  getRandomPosition() {
    const randomTarget = Utils.getRandomElementFromArray(this.numberGrid.numbers)
    return {
      x: this.numberGrid.x + randomTarget.x,
      y: this.numberGrid.y + randomTarget.y,
    }
  }

  async skip(numbers: number[]) {
    this.skipToEnd = true

    this.numberGrid.skip(numbers)
    this.onNumberSelected(numbers.length - 1)
  }

  async targetNumbers(numbers: number[]) {
    for (let i = 0; i < numbers.length; i++) {
      if (this.skipToEnd) {
        return
      } else {
        await this.preNumberSelected(i)
        await this.targetSingleNumber(numbers[i])
        await this.targetMiniGameSelection(numbers[i])
      }
      if (!this.skipToEnd) {
        this.onNumberSelected(i)
      }
    }
  }

  async targetMiniGameSelection(value: number) {
    if (this.miniGameSelections.includes(value)) {
      await tweenWaitPromise(this.scene, 750)()
    }
  }
}
